<i2g-job-preview-title
  [title]="file.title"
  [description]="file.description"
  class="preview-title"
></i2g-job-preview-title>

<div class="preview-file-container">
  <i2g-file-preview
    [name]="file.title"
    [url]="file.url"
    [mimeType]="file.mimeType"
    class="preview-file"
  ></i2g-file-preview>
</div>
